// src/modules/app-views/products/pages/Document/actions/dropdownMenu.js

import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownParameters,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const productsDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
      dropdownDivider,
      dropdownParameters,
    ],
  };
};

export default productsDocumentMenuButton;
